import * as React from "react";
import { CompanyDto } from "Api/Api";
import styled from "styled-components";
import { useResource, Resources } from "Translations/Resources";

type Props = {
  company: CompanyDto;
};

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const getRoleResource = (companyDto: CompanyDto) => {
  let resources = [];
  if (!companyDto) {
    return "";
  }
  if (companyDto.isCustomer) {
    resources.push("Odběratel");
  }
  if (companyDto.isSupplier) {
    resources.push("Dodavatel");
  }

  if (companyDto.isMarketplaceEnabled) {
    resources.push("Marketplace");
  }

  return resources.join(", ");
};

export const CompanyDetailRole: React.FunctionComponent<Props> = props => {
  const { company } = props;
  const { t } = useResource();

  const isEmptyRole = (companyDto: CompanyDto) => {
    const roleResource = getRoleResource(companyDto);
    return !roleResource || roleResource === "";
  };

  return (
    <>
      {!isEmptyRole(company) && (
        <>
          <StyledWrapper className={"row"}>
            <div className={"row-title"}>
              {t(Resources.Companies.Detail.Role)}
            </div>
            <div>{getRoleResource(company)}</div>
          </StyledWrapper>
          <hr />
        </>
      )}
    </>
  );
};
